import React, { Component } from 'react';
import styled from 'styled-components';
import Link from 'valuelink';
import { Button, Col, message, Row, Select, Spin, Switch, Upload, Icon } from 'antd';
import { Input } from 'valuelink/lib/tags';
import { SemiboldText, ButtonText } from '../../components/common/Text';
import { fetchBasicProfile, submitDoctorFulfilment } from '../../services';
import { connect } from 'react-redux';
import { uploadDocument, removeDocument, getDocuments } from '../../services';
const { Option } = Select;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 14px;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
class DoctorFulfilmentScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      payeeName: '',
      accountNumber: '',
      accountType: '',
      ifscCode: '',
      paytmNumber: '',
      upiAddress: '',
      visitSpoc: '',
      preferredPaymentMode: 'Bank Account',
      paymentCycle: 'before consultation',
      remarks: '',
      invoiceMandatory: 0,
      visitPrice: 0,
      doctorDetails: {},
      panNumber: '',
      nameOnPanCard: '',
      fileList: []
    };
    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    if (this.doctorId) {
      this.fetchProfile();
    }
  };

  handlePreview = (file) => {
    let promise = Promise.resolve();
    if (!file.url && !file.preview) {
      promise = getBase64(file.originFileObj);
    }
    return promise.then((preview) => {
      file.preview = preview;
      this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle:
          file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
    });
  };

  handlePanDocumentChange = ({ fileList }) => {
    console.log(fileList, 'on change');
    // this.setState({ fileList });
  };

  handlePanDocumentRemove = (response) => {
    console.log(response, 'On Remove');
    return removeDocument(response.uid);
  };

  handlePanDocumentUpload = (response) => {
    console.log(response.file.uid, 'HandleUpload Response UID Check');
    return uploadDocument(
      this.doctorId,
      null,
      'pan_card',
      response.file,
      response.onProgress
    )
      .then((response) => {
        this.fetchDocs();

        response.onSuccess(response, response.file);
      })
      .catch((err) => {
        response.onError(err);
      });
  };

  fetchDocs = () => {
    const { doctorId, centerId } = this.props;
    getDocuments(doctorId, centerId)
      .then((response) => {
        const fileList = response.documents.map((d) => {
          return {
            uid: d.documentId,
            type: d.type,
            name: d.type,
            status: 'done',
            url: d.link,
          };
        });
        this.setState({
          fileList: [fileList[fileList.length - 1]] || [],
        });
      });
  };

  fetchProfile = () => {
    this.setState({ loading: true });
    fetchBasicProfile(this.doctorId)
      .then(res => {
        const basicProfile = res;
        const { fulfilment, data } = basicProfile;
        this.setState({ doctorDetails: data });
        if (fulfilment) {
          this.setState({
            assistantName: fulfilment.assistantName || '',
            assistantNumber: fulfilment.assistantNumber || '',
            payeeName: fulfilment.payeeName || '',
            accountNumber: fulfilment.accountNumber || '',
            accountType: fulfilment.accountType || '',
            ifscCode: fulfilment.ifscCode || '',
            paytmNumber: fulfilment.upiPhone || '',
            upiAddress: fulfilment.upiAddress || '',
            visitSpoc: fulfilment.visitSpoc || '',
            preferredPaymentMode: fulfilment.preferredPayment || '',
            paymentCycle: fulfilment.paymentCycle || '',
            remarks: fulfilment.remarks || '',
            invoiceMandatory: fulfilment.invoiceMandatory || 0,
            visitPrice: fulfilment.visitPrice || 0,
            panNumber: fulfilment.panNumber || '',
            nameOnPanCard: fulfilment.panName || '',
            fileList: fulfilment.panLink ? [{ url: fulfilment.panLink, name: 'pan_card', status: 'done', uid: 0 }] : []
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  isPANValid = (panNumber) => {
    const panRegex = /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/;
    return panRegex.test(panNumber);
  };

  valueOrUndefined = value => {
    return value.trim() === '' ? undefined : value;
  };

  submit = () => {
    const {
      payeeName,
      accountNumber,
      accountType,
      ifscCode,
      paytmNumber,
      upiAddress,
      visitSpoc,
      preferredPaymentMode,
      paymentCycle,
      remarks,
      invoiceMandatory,
      visitPrice,
      doctorDetails,
      panNumber,
      nameOnPanCard,
      fileList
    } = this.state;

    if (panNumber && !this.isPANValid(panNumber)) {
      return message.error('Invalid PAN Number', 3);
    }
    if (panNumber && !this.valueOrUndefined(nameOnPanCard)) {
      return message.error('Name on PAN should not be empty', 3);
    }
    if (visitSpoc === '' || payeeName === '') {
      return message.error(
        'Kindly fill mandatory fields Visit Spoc and Payee Name',
        3
      );
    }
    const fulfilmentDetails = {
      payeeName: payeeName,
      accountNumber: this.valueOrUndefined(accountNumber),
      accountType: this.valueOrUndefined(accountType),
      ifsc: this.valueOrUndefined(ifscCode),
      upiPhone: this.valueOrUndefined(paytmNumber.toString()),
      upiAddress: this.valueOrUndefined(upiAddress),
      paymentCycle: this.valueOrUndefined(paymentCycle),
      invoiceMandatory,
      panNumber,
      nameOnPanCard: this.valueOrUndefined(nameOnPanCard),
      panLink: this.valueOrUndefined(fileList[0] ? fileList[0].url : '')
    };
    if (doctorDetails.isOnlineDoctor) {
      fulfilmentDetails.visitPrice = visitPrice;
    }
    console.log({ fulfilmentDetails });
    this.setState({ loading: true });
    submitDoctorFulfilment(
      this.doctorId,
      fulfilmentDetails,
      preferredPaymentMode,
      visitSpoc,
      this.valueOrUndefined(remarks)
    )
      .then(result => {
        if (result.errorMessage) {
          message.warn(
            `Fulfilment saved with warning.
          ${result.errorMessage}`,
            6
          );
        }
        message.success('Success', 3);
        this.fetchProfile();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      loading,
      preferredPaymentMode,
      paymentCycle,
      visitSpoc,
      invoiceMandatory,
      doctorDetails,
      fileList
    } = this.state;
    const payeeNameInputLink = Link.state(this, 'payeeName');
    const accountNumberInputLink = Link.state(this, 'accountNumber');
    const accountTypeInputLink = Link.state(this, 'accountType');
    const ifscCodeInputLink = Link.state(this, 'ifscCode');
    const paytmNumberInputLink = Link.state(this, 'paytmNumber');
    const upiAddressInputLink = Link.state(this, 'upiAddress');
    const remarksInputLink = Link.state(this, 'remarks');
    const visitPriceLink = Link.state(this, 'visitPrice');
    const panNumberLink = Link.state(this, 'panNumber');
    const nameOnPanCardLink = Link.state(this, 'nameOnPanCard');
    return (
      <Row type="flex" gutter={[16, 16]}>
        <Col span={24}>
          <TitleText>Doctor Fulfilment</TitleText>
        </Col>
        {loading ? (
          <Spin spinning={loading} />
        ) : (
          <Col xs={{ order: 2, span: 24 }} md={{ order: 1, span: 12 }}>
            <Row gutter={[16, 16]}>
              {/* {this.state.validationErrors.dependentName ? (
              <ValidationText>
                {this.state.validationErrors.dependentName.errorMessage}
              </ValidationText>
            ) : null} */}
              <Col span={12}>
                <LabelText>Preferred Payment Mode</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={preferredPaymentMode}
                  defaultValue="Bank Account"
                  onChange={(e) => this.setState({ preferredPaymentMode: e })}
                >
                  <Option value="Bank Account">Bank Account</Option>
                  <Option value="UPI">UPI</Option>
                  <Option value="Paytm">Paytm</Option>
                </Select>
              </Col>

              <Col span={12}>
                <LabelText>Payee Name</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={payeeNameInputLink}
                  placeholder="Payee Name"
                />
              </Col>

              {preferredPaymentMode === 'Bank Account' ? (
                <Col span={12}>
                  <LabelText>Account Number</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={accountNumberInputLink}
                    placeholder="Account Number"
                  />
                </Col>
              ) : null}

              {preferredPaymentMode === 'Bank Account' ? (
                <Col span={12}>
                  <LabelText>Account Type</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={accountTypeInputLink}
                    placeholder="Account Type"
                  />
                </Col>
              ) : null}

              {preferredPaymentMode === 'Bank Account' ? (
                <Col span={12}>
                  <LabelText>IFSC Code</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={ifscCodeInputLink}
                    placeholder="IFSC Code"
                  />
                </Col>
              ) : null}

              {/* {preferredPaymentMode === 'Paytm' ? ( */}
              <Col span={12}>
                <LabelText>PayTM Number</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={paytmNumberInputLink}
                  placeholder="PayTM Number"
                />
              </Col>
              {/* ) : null} */}

              {preferredPaymentMode === 'UPI' ? (
                <Col span={12}>
                  <LabelText>UPI Address</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={upiAddressInputLink}
                    placeholder="UPI ID"
                  />
                </Col>
              ) : null}

              <Col span={24}>
                <LabelText>Payment Cycle</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={paymentCycle}
                  defaultValue="before consultation"
                  onChange={(e) => this.setState({ paymentCycle: e })}
                >
                  <Option value="before consultation">
                    Before consultation
                  </Option>
                  <Option value="after consultation">After consultation</Option>
                  <Option value="within 2">Within 2 days</Option>
                  <Option value="within 7">Within 7 days</Option>
                  <Option value="within 15">Within 15 days</Option>
                  <Option value="30 Days">30 days</Option>
                </Select>
              </Col>
              <Col span={12}>
                <LabelText>PAN Card Number</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={panNumberLink}
                  placeholder="PAN Card Number"
                />
              </Col>
              <Col span={12}>
                <LabelText>Name on PAN Card</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={nameOnPanCardLink}
                  placeholder="Name on PAN Card"
                />
              </Col>
              <Col span={24}>
                <div
                  style={{
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ marginRight: '5px' }}>PAN Card Document:</span>
                  <Upload
                    accept="image/*,application/pdf"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handlePanDocumentChange}
                    onRemove={this.handlePanDocumentRemove}
                    customRequest={this.handlePanDocumentUpload}
                  >
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                </div>
              </Col>
              <Col span={12}>
                <LabelText>Visit Spoc</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={visitSpoc}
                  // defaultValue="Select Visit Spoc"
                  onChange={(e) => this.setState({ visitSpoc: e })}
                >
                  {this.props.visitSpocs.map((spoc) => (
                    <Option key={spoc.operatorId} value={spoc.operatorId}>
                      {spoc.name}
                    </Option>
                  ))}
                </Select>
              </Col>

              {doctorDetails.isOnlineDoctor ? (
                <Col span={12}>
                  <LabelText>Visit Price</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={visitPriceLink}
                    placeholder="Visit Price"
                  />
                </Col>
              ) : null}

              <Col span={12}>
                <LabelText>Remarks</LabelText>
                <StyledInputBox
                  className="visit-input"
                  valueLink={remarksInputLink}
                  placeholder="Remarks"
                />
              </Col>
              <Col span={12}>
                <LabelText>Invoice Mandatory</LabelText>
                <Switch
                  checked={invoiceMandatory}
                  onChange={() =>
                    this.setState({ invoiceMandatory: !invoiceMandatory })
                  }
                />
              </Col>
              <Col span={24}>
                <Button block type="primary" size="large" onClick={this.submit}>
                  <ButtonText>Submit</ButtonText>
                </Button>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    visitSpocs: state.info.operators,
  };
}

export default connect(mapStateToProps)(DoctorFulfilmentScreen);
